import { AlertTriangle } from 'lucide-react';
import { useTranslation } from '@infra/i18n';
import { environment } from '@shared/config';

/**
 * Sandbox/demo disclaimer rendered as a thin full-width strip at the very top of
 * the header (above the top-bar row). Shown only when the demo flag
 * (VITE_DEMO_MODE) is on. An in-flow strip — the header places it inside its
 * sticky region so it stays pinned to the top with the header.
 */
export function SandboxNotice() {
  const { t } = useTranslation();

  if (!environment.isDemoMode) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="sandbox-notice"
      className="flex w-full items-center justify-center gap-2 border-b border-tone-caution-edge/70 bg-tone-caution-surface/95 px-4 py-2 backdrop-blur-sm"
    >
      <AlertTriangle className="h-4 w-4 shrink-0 text-tone-caution" aria-hidden="true" />
      <p className="text-center text-[11px] font-medium leading-snug text-tone-caution-ink">
        {t('common:sandbox.disclaimer')}
      </p>
    </div>
  );
}
